__webpack_require__.p = "/assets/turbo/925f00a5/quellede/_next/";